import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';

// Components
import SVG from 'components/widgets/icons/svg';


export default function ResolveWithTimeOption({ triageItem }) {
  const ticketed = !_.isEmpty(triageItem.ticket);
  const classes = classNames({ disabled: !_.isEmpty(triageItem.ticket) }, 'triage-option-header');

  return (
    <div className="triage-option-time">
      <div onClick={ticketed ? _.noop : () => triageItem.setOpen('resolveWithTime')} className={classes}>
        <SVG src="svg/time-report.svg" className="time-report triage-option-icon" />
        <span>QR Time</span>
      </div>
    </div>
  );
}

ResolveWithTimeOption.propTypes = {
  triageItem: PropTypes.object.isRequired
};
